<template>
  <TabelaPaginada
    :sem-titulo="semTitulo"
    :titulo="titulo"
    :colunas="colunasLocal"
    :pagina="pagina"
    :mantem-estado="mantemEstado"
    @trocar-pagina="onTrocaPagina"
    @ordenar="onOrdenar"
  >
    <template slot="cabecalho">
      <slot name="cabecalho" />
    </template>

    <template slot="tbody">
      <slot name="tbody">
        <template v-for="(item, index) in pagina.content">
          <tr
            :row-id="`row-${index}`"
            :key="`row-${item.id}-${index}`"
            @click="onClickItem(item)"
          >
            <td
              v-if="abrirLinha"
              col-id="conferidos-tabela-button-abrir-linha"
              class="text-center"
            >
              <b-button @click="onAbrirLinha(item)" variant="link">
                <md-icon v-if="linhasAbertas.includes(item.id)">
                  expand_less
                </md-icon>
                  <md-icon  v-if="!linhasAbertas.includes(item.id)">
                  expand_more
                </md-icon>
              </b-button>
            </td>

            <template v-for="( coluna, colIndex ) in colunas">
              <td :class="coluna.classes" :key="`col-${index}-${colIndex}`" >
                <template v-if="coluna.tipo == null || coluna.tipo == 'label'">
                  <template v-if="typeof coluna.campo === 'function'">
                    {{ coluna.campo(item) }}
                  </template>
                  <template v-else>
                    {{ item[coluna.campo] }}
                  </template>
                </template>
                <badge-status
                  v-if="coluna.tipo === 'status' || coluna.tipo === 'mini-status' "
                  :mini="coluna.tipo === 'mini-status'"
                  :status="item[coluna.campo]"
                  :ativo-text="$t('label.ativo')"
                  :inativo-text="$t('label.inativo')"
                />
              </td>
            </template>

            <td v-if="exibeAcoes == null || exibeAcoes" class="text-center">
              <slot v-bind:item="item" name="acoes" />
            </td>
          </tr>
          <transition :key="`row-transition-info-${index}`">
            <tr
              :row-id="`row-info-${index}`"
              :key="`row-info-${index}`"
              v-if="linhasAbertas.includes(item.id)"
            >
              <td :colspan="colunasLocal.length">
                <slot v-bind:item="item" name="row-content" />
              </td>
            </tr>
          </transition>
        </template>
      </slot>
    </template>
  </TabelaPaginada>
</template>

<script>
import TabelaPaginada from "./TabelaPaginada";
import { SemaforoBoolFilter } from "../filters/semaforo-bool.filter";
import { NovaPagina } from "./pagina.service";
import BadgeStatus from "../misc/BadgeStatus";

export default {
  name: "TabelaPadrao",
  components: {
    BadgeStatus,
    TabelaPaginada
  },
  filters: {
    semaforoBool: SemaforoBoolFilter
  },
  props: {
    pagina: {
      type: Object,
      default: () => {
        return new NovaPagina();
      }
    },
    colunas: Array,
    semTitulo: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: null
    },
    abrirLinha: {
      type: Boolean,
      default: false
    },
    exibeAcoes: {
      type: Boolean,
      default: false
    },
    clickItem: {
      type: Boolean,
      default: false
    },
    mantemEstado: {
      type: Boolean,
      default: false
    },
  },
  data,
  watch: {
    colunas() {
      this.montaColunas();
    }
  },
  mounted,
  methods: {
    montaColunas,
    onTrocaPagina,
    onAbrirLinha,
    onOrdenar,
    onClickItem
  }
};
function data() {
  return {
    linhasAbertas: [],
    colunasLocal: []
  };
}

function onOrdenar(campo) {
  this.$emit("ordenar", campo);
}

function onTrocaPagina(pagina) {
  this.$emit("trocaPagina", pagina);
}

function mounted() {
  this.montaColunas();
}

function montaColunas() {
  this.colunasLocal = [];
  this.colunasLocal.push(...this.colunas);

  if (this.exibeAcoes == null || this.exibeAcoes) {
    this.colunasLocal.push({
      nome: this.$t("label.acoes"),
      classes: "pb-4 table-action"
    });
  }

  if (this.abrirLinha) {
    this.colunasLocal.unshift({ nome: "", classes: "text-center table-10" });
  }
  if (this.paginaEditarLocal == null) {
    this.paginaEditarLocal = `${this.$route.name}-edicao-id`;
  }
}

function onAbrirLinha(item) {
  const indexItem = this.linhasAbertas.indexOf(item.id);

  if (indexItem > -1) {
    this.linhasAbertas.splice(indexItem, 1);
  } else {
    this.linhasAbertas.push(item.id);
  }

  this.$emit("abrir-linha", item, !(indexItem > -1));
}

function onClickItem(item) {
  this.$emit("click-item", item, this.clickItem);
}
</script>
